import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ApplicationModalContext = createContext(null);

export const ApplicationModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefillAmount, setPrefillAmount] = useState('');
  const [prefillTerm, setPrefillTerm] = useState('');

  const openModal = useCallback((options = {}) => {
    const amt = options.amount != null && options.amount !== '' ? String(options.amount) : '';
    const trm = options.term != null && options.term !== '' ? String(options.term) : '';
    setPrefillAmount(amt);
    setPrefillTerm(trm);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({ open, prefillAmount, prefillTerm, openModal, closeModal }),
    [open, prefillAmount, prefillTerm, openModal, closeModal]
  );

  return (
    <ApplicationModalContext.Provider value={value}>
      {children}
    </ApplicationModalContext.Provider>
  );
};

export const useApplicationModal = () => {
  const ctx = useContext(ApplicationModalContext);
  if (!ctx) {
    throw new Error('useApplicationModal must be used within ApplicationModalProvider');
  }
  return ctx;
};
